<template>
  <editor v-model="content" @init="editorInit" :options="options" lang="xml" width="100%" height="500"></editor>
</template>
<script>
export default {
  name: 'Veditor',
  props : [
      'text',
      'options'
  ],
  data() {
    return {
        content: ''
    }
  },
  mounted() {
    this.content = this.text
  },
  watch: {
    text: function (newVal,oldVal) {
      this.content = newVal;
    }
  },
  components: {
    editor: require('vue2-ace-editor'),
  },
  methods: {
        editorInit: function () {
            
            require('brace/mode/xml')                
            require('brace/theme/chrome')

        }
  }
}
</script>